import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import DownloadSVG from "./../../../../../Assets/icons/DownloadIconMIS.svg";
import './index.scss';
import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import Loader from '../../../../customComponents/CustomLoader';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import { Colors } from 'chart.js';
import { FiDownload } from "react-icons/fi";


const ProductColorList = () => {
  const [productColorData, setProductColorData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [totalInactive, setTotalInactive] = useState(0)

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const fetchProductColorList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/color/list', {
        orderBy: 'color_id desc',
        page,
        pageSize,
        searchText: searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setProductColorData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      console.log("totalpages", totalPages);
    } catch (error) {
      console.error('Error fetching product color list:', error);
    }
    finally {
      setLoading(false)
    }
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductColorList(newPage);
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };

    try {
      const response = await axiosInstance.post("/color/color-report-excel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "color.csv";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };
  const TABLE_HEADERS = [
    // "Sr No.",
    // "Color ID",
    "Name",
    "Description",
    "Status",
    "Action"
  ];

  const keyMapping = {
    // "Sr No.": "Sr No.",
    // "Color ID": "color_id",
    "Name": "color_name",
    "Description": "color_desc",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITPRODUCTCOLOR}`, { state: { data: rowData } });

  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchProductColorList();
    }
  }, [searchTerm]);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <><div className='OnboardManagamentContainer'>
          <div className='OnboardManagamentbuttonContainer'>
            <h5>Colors</h5>
          </div>
          <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
            <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }}>
              <h5 className="listTopDataValueText">{totalData} </h5>
              <h6>All Color</h6>
            </div>
            <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }}>
              <h5 className="listTopDataValueText">{totalActive} </h5>
              <h6>Active Color</h6>
            </div>
            <div className='topleftdataContainer'>
              <h5 className="listTopDataValueText">{totalInactive} </h5>
              <h6>Inactive Color</h6>
            </div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-product/color/add-product-color')}>
              Add Color
            </button>
          </div>
        </div><div className='tableWrapper'>
            <div className='admin-list-container'>
              <div className='listsearchContainer'>
                <h5>Colors List</h5>
                <div>
                  <SearchInput
                    placeholder="Search Color"
                    onSearch={fetchProductColorList}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div
                  onClick={downloadExcel}
                  className="flte-btnnn"
                  style={{ borderRadius: "38px", cursor: "pointer" }}
                >
                  Export
                  <span>
                    <FiDownload className="downloadexcel-misreportsales" style={{ cursor: "pointer" }} size={22} />
                  </span>
                </div>

              </div>
            </div>
            <CustomTable
              data={productColorData}
              headers={TABLE_HEADERS}
              keyMapping={keyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords} />
          </div></>
      )}
    </div>
  )
}

export default ProductColorList;
